module.exports = __webpack_public_path__ + "img/1443122970.832900e2.jpg";